import { Form } from 'antd';
import { CALENDAR_PICKER_TYPE } from 'features/settingStaff/services/constants';
import DateControlInput from './components/DateControlInput';
import moment from 'moment';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import styled from 'styled-components';
import useGetConsentReport from 'features/report/services/hooks/useGetConsentReport';
import { IApiGetConsentFormReportParam } from 'features/report/services/types/api';
import SelecctCustomer from './components/SelecctCustomer';
import ConsentFormTable from './components/ConsentFormTable';
import { REPORT_PAGE_SIZE } from 'features/report/services/constants';

export type TConsentFormReport = {
  customerId: {
    id: string;
    name: string;
  } | null;
  date: {
    startDate: string;
    endDate: string;
    viewType: CALENDAR_PICKER_TYPE;
  };
};

const initialValues: TConsentFormReport = {
  customerId: null,
  date: {
    startDate: moment().format(DATE_FORMAT),
    endDate: moment().format(DATE_FORMAT),
    viewType: CALENDAR_PICKER_TYPE.DATE,
  },
};

const ConsentFormReport = () => {
  const [form] = Form.useForm<TConsentFormReport>();
  const { data, mutate, pagination } = useGetConsentReport();

  const onValuesChange = (_: any, allValues: TConsentFormReport) => {
    const params: IApiGetConsentFormReportParam = {
      customerId: allValues.customerId?.id,
      startDate: allValues.date.startDate,
      endDate: allValues.date.endDate,
      page: 1,
      size: REPORT_PAGE_SIZE,
    };
    mutate(params);
  };
  const handleChangePage = (page: number) => {
    const values = form.getFieldsValue();
    const params: IApiGetConsentFormReportParam = {
      customerId: values.customerId?.id,
      startDate: values.date.startDate,
      endDate: values.date.endDate,
      page: page,
      size: REPORT_PAGE_SIZE,
    };
    mutate(params);
  };
  return (
    <Wrapper>
      <Form form={form} initialValues={initialValues} onValuesChange={onValuesChange}>
        <Container>
          <TitleH2>Consent Form({pagination.total})</TitleH2>
          <div style={{ flex: 1 }}>
            <FormItemStyled name='customerId'>
              <SelecctCustomer />
            </FormItemStyled>
          </div>

          <FormItemStyled name='date'>
            <DateControlInput />
          </FormItemStyled>
        </Container>
      </Form>
      <ConsentFormTable data={data} pagination={pagination} handleChangePage={handleChangePage} />
    </Wrapper>
  );
};

export default ConsentFormReport;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
`;

const FormItemStyled = styled(Form.Item)`
  margin: 0;
`;
const TitleH2 = styled.div`
  color: #1d2129;
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: none;
`;
